"use client";

import { useTranslations } from "next-intl";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/navigation";
import React, { FC, useContext, useMemo } from "react";

import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "@/components/ui/Button/Button";
import Icon from "@/components/ui/Icon/Icon";
import { UTMParametersContext, getFallbackCampaignParameters } from "@/context/UTMParametersContext";
import { contactChannelTracking, ctaClickTracking } from "@/dataLayer/dataLayer";
import { HeaderProps } from "@/types";

import AnchorLink from "../ui/AnchorLink/AnchorLink";

const customClass = "text-black font-secondary text-s";
const variation = "text-black";
const HeaderCheckout: FC<HeaderProps> = ({ logoDark, contactChannels, locale }) => {
  const t = useTranslations();
  const callLink = useMemo(() => {
    return Array.isArray(contactChannels) ? contactChannels.find((item) => /phone/i.test(item?.link?.icon || "")) : undefined;
  }, [contactChannels]);

  const router = useRouter();

  const { utmParameters } = useContext(UTMParametersContext);

  return (
    <div className="fixed transition-all w-full top-0 md:block z-50 bg-white">
      <header className="flex items-center justify-between gap-s px-m py-[18px] w-full m-auto md:w-20\/24">
        <button
          type="button"
          onClick={() => {
            router.back();
          }}
        >
          <span className="flex items-center gap-xs">
            <Icon className="stroke-black" name="arrow-left" size="24" title={callLink?.label} />
          </span>
        </button>
        <Link href={`/${locale}/`} aria-label={t("button.label.homepage")}>
          <Image className={`h-m md:h-l`} src={logoDark?.url} width={134} height={20} alt={logoDark?.title} />
        </Link>

        <Button
          className="p-s md:p-0 no-underline flex items-center md:inline-block whatsapp-button relative"
          size={ButtonSize.MEDIUM}
          theme={ButtonTheme.WHITE}
          type="button"
          variant={ButtonVariant.TERTIARY}
          href={`tel:${getFallbackCampaignParameters(utmParameters?.utm_medium)?.virtual_number || "+97145205400"}`}
          poneNumberCta={() => {
            contactChannelTracking(t("label.common.callus"));
            ctaClickTracking(t("label.common.callus"), "ContactChannels", "ContactChannels");
          }}
        >
          <span className="flex items-center justify-between gap-xs w-full">
            <span className={`${customClass ? customClass : ""}`}>{t("label.common.callus")}</span>
            <Icon className={`stroke-black ${variation ? variation : ""}`} name="phone" size={`${"20"}`} title={t("label.common.phone")} />
          </span>
        </Button>
      </header>
    </div>
  );
};
export default HeaderCheckout;
